/**
 * Inline auto-save status text shown in the modal header. Purely presentational
 * — driven by the auto-save hook's state plus whether any field is still dirty.
 */
export function DgaSaveStatus({
  isSaving,
  lastError,
  lastSavedAt,
  hasUnsavedChanges,
}: {
  isSaving: boolean;
  lastError: Error | null;
  lastSavedAt: Date | null;
  hasUnsavedChanges: boolean;
}) {
  if (isSaving) {
    return <span className="text-xs text-on-surface-muted">Saving...</span>;
  }
  if (lastError) {
    return (
      <span className="text-xs text-error">
        There was a problem saving. Please try again.
      </span>
    );
  }
  // Never report "Changes saved" while fields are still dirty — otherwise an
  // unsaved field can look identical to a fully-saved form. Pending changes
  // are debounced/queued and will save shortly (or retry after error on next edit).
  if (hasUnsavedChanges) {
    return <span className="text-xs text-on-surface-muted">Saving...</span>;
  }
  if (lastSavedAt) {
    return <span className="text-xs text-on-surface-muted">Changes saved</span>;
  }
  return null;
}
